import { render, staticRenderFns } from "./solutionSand.vue?vue&type=template&id=1bc9b846&scoped=true&"
import script from "./solutionSand.vue?vue&type=script&lang=js&"
export * from "./solutionSand.vue?vue&type=script&lang=js&"
import style0 from "./solutionSand.vue?vue&type=style&index=0&id=1bc9b846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc9b846",
  null
  
)

export default component.exports